<template>

  <div class="padded">
    <div class="dash-heading">Nearby Places ({{places.results && places.results.length ? places.results.length : 0}})</div>


    <el-row :gutter="88" type="flex" justify="center">

      <el-col :span="8" align="center">

        <el-tooltip :placement="pl" content="Select points of intrest">

          <el-select v-model="type" size="small" placeholder="Select POI">

              <el-option
                v-for="item in poiSelect"
                :key="item.value"
                :label="item.label"
                :value="item.value">
                  <span style="float: left"><i :class="item.icon" />&nbsp;{{ item.label }}</span>
                </el-option>

            </el-select>

        </el-tooltip>
      </el-col>



      <el-col :span="10" align="center">

        <el-tooltip :placement="pl" content="Select range in m. to search">

          <el-slider
            v-model="mRadius"
            :min="500"
            :max="2000"
            :step="25"
            show-stops
            show-input />

          </el-tooltip>

      </el-col>

    </el-row>

    <el-table
      :data="places.results"
      style="width: 100%"
      height="50vh"
      :row-class-name="tableRowClassName">

    <el-table-column
      prop="name"
      label="Name"
      fixed
      swidth="180">
      <template slot-scope="scope">
        <b>{{scope.row.name}}</b>
      </template>
    </el-table-column>



    <el-table-column
      prop="vicinity"
      label="Address" />

    <el-table-column
      prop="rating"
      label="Rating">
      <template slot-scope="scope">
        <el-rate v-model="scope.row.rating" disabled />
        <small v-if="scope.row.user_ratings_total">Total Ratings:&nbsp;<b>({{formatInteger(scope.row.user_ratings_total)}})</b></small>
      </template>
    </el-table-column>

    <el-table-column
      prop="types"
      label="Type" />

  </el-table>
</div>

</template>


<script>

import GoogleMapMixins from '@/mixins/GoogleMapMixins'

export default {

  mixins: [GoogleMapMixins],

  props: {

    lat: {
      type: Number,
      required: true
    },

    lng: {
      type: Number,
      required: true
    },

    radius: {
      type: Number,
      default: 1
    },

    filterClosed: {
      type: Boolean,
      default: true
    }

  },

  methods: {
    isOpen (row) {
      return (row && row.business_status === 'OPERATIONAL') ? true : false
    },

    isClosed (row) {
      return (row && row.business_status === 'CLOSED_PERMANENTLY') ? true : false
    },

    isTemporary (row) {
      return (row && row.business_status === 'CLOSED_TEMPORARILY') ? true : false
    },

    tableRowClassName ({row, rowIndex}) {
      let cls = ''

      if (this.isTemporary(row)) {
        cls = 'temporary-row'
      } else if (this.isClosed(row)) {
        cls = 'closed-row'
      } else if (this.isOpen(row)) {
        cls = 'open-row'
      }

//      console.log(row.business_status, cls)
      return cls
    }
  },



  data () {
    return {
      pl: 'left',
      mRadius: this.radius * 1000,
      type: null,

      poiSelect: [
        {label: 'All', value: null, icon: 'fa fa-globe'},
        {label: 'Airport', value: 'airport', icon: 'fa fa-plane-departure'},
        {label: 'Bank', value: 'bank', icon: 'fa fa-landmark'},
        {label: 'Bus Station', value: 'bus_station', icon: 'fa fa-bus'},
        {label: 'Car Repair', value: 'car_repair', icon: 'fa fa-car-crash'},
        {label: 'Church', value: 'church', icon: 'fa fa-church'},
        {label: 'Department Store', value: 'department_store', icon: 'fa fa-store'},
        {label: 'Gas/Petrol Station', value: 'gas_station', icon: 'fa fa-gas-pump'},
        {label: 'Hindu Temple', value: 'hindu_temple', icon: 'fa fa-gopuram'},
        {label: 'Hospital', value: 'hospital', icon: 'fa fa-hospital-symbol'},
        {label: 'Hotel', value: 'lodging', icon: 'fa fa-hotel'},
        {label: 'Library', value: 'library', icon: 'fa fa-book-open'},
        {label: 'LRT', value: 'light_rail_station', icon: 'fa fa-shuttle-van'},
        {label: 'Local Govt.', value: 'local_government_office', icon: 'fa fa-city'},
        {label: 'Mosque', value: 'mosque', icon: 'fa fa-mosque'},
        {label: 'Pharmacy', value: 'pharmacy', icon: 'fa fa-prescription'},
        {label: 'Police', value: 'police', icon: 'fa fa-gavel'},
        {label: 'Post Ofice', value: 'post_office', icon: 'fa fa-mail-bulk'},
        {label: 'Shopping Mall', value: 'shopping_mall', icon: 'fa fa-gifts'},
        {label: 'School', value: 'school', icon: 'fa fa-school'},
        {label: 'Primary School', value: 'primary_school', icon: 'fa fa-chalkboard'},
        {label: 'Secondary School', value: 'secondary_school', icon: 'fa fa-chalkboard-teacher'},
        {label: 'Store', value: 'store', icon: 'fa fa-store-alt'},
        {label: 'Subway Station', value: 'subway_station', icon: 'fa fa-subway'},
        {label: 'Supermarket', value: 'supermarket', icon: 'fa fa-shopping-cart'},
        {label: 'Synagogue', value: 'synagogue', icon: 'fa fa-synagogue'},
        {label: 'Train Station', value: 'train_station', icon: 'fa fa-train'},
        {label: 'Transit Station', value: 'transit_station', icon: 'fa fa-bus-alt'},
        {label: 'Tourist Attraction', value: 'tourist_attraction', icon: 'fa fa-map-signs'},
        {label: 'University', value: 'university', icon: 'fa fa-graduation-cap'}
      ]
    }
  },

  mounted () {
    this.loadPoi(this.lat, this.lng, this.mRadius, this.type, this.places)
  }
}
</script>

<style scoped>
.open-row {
  background: mintcream;
}

.temporary-row {
  background: oldlace;
}

.closed-row {
  background: mistyrose;
}
</style>
